(ns minorodata.components.warehouse-usage.shared
  (:require
   ["date-fns" :refer [differenceInCalendarDays format parseISO startOfMonth subDays subMonths]]
   [reagent.core :as reagent]
   [ui.card :as card]))

(defonce timeframe
  (reagent/atom {:from (startOfMonth (subMonths (js/Date.) 1))
                 :to   (js/Date.)}))

(defn previous-window [{:keys [from to]}]
  (let [from-d    (parseISO from)
        to-d      (parseISO to)
        days      (differenceInCalendarDays to-d from-d)
        prev-to   (subDays from-d 1)
        prev-from (subDays prev-to days)]
    {:from (format prev-from "yyyy-MM-dd")
     :to   (format prev-to "yyyy-MM-dd")}))

(defn state-card [content]
  [card/card {:class "rounded-lg"}
   [card/card-content {:class "flex min-h-48 items-center justify-center p-6"}
    content]])

(defn empty-state [icon text]
  [:div {:class "flex flex-col items-center gap-2 py-4 text-center text-kleene-text-secondary"}
   [:> icon {:size 20 :class "opacity-60"}]
   [:span {:class "text-sm"} text]])

(defn chart-card [title action content]
  [card/card {:class "rounded-lg"}
   [card/card-content {:class "p-6"}
    [:div {:class "mb-6 flex items-center justify-between gap-4"}
     [card/card-title title]
     action]
    content]])

(defn ellipsize [s n]
  (let [s (str s)]
    (if (> (count s) n)
      (str (subs s 0 (max 0 (- n 1))) "…")
      s)))

(def number-formatter
  (js/Intl.NumberFormat. "en-GB" #js {:minimumFractionDigits 1 :maximumFractionDigits 1}))

(defn format-number [value]
  (if (nil? value) "—" (.format number-formatter value)))

(def integer-formatter
  (js/Intl.NumberFormat. "en-GB"))

(defn format-integer [value]
  (if (nil? value) "—" (.format integer-formatter value)))

(def ^:private byte-units ["B" "KB" "MB" "GB" "TB" "PB"])

(defn format-bytes [value]
  (if (nil? value)
    "—"
    (loop [value (double value) units byte-units]
      (if (or (< value 1024) (empty? (rest units)))
        (str (.toFixed value (if (< value 10) 1 0)) " " (first units))
        (recur (/ value 1024) (rest units))))))

(def bucket-date-key "__usage_bucket_date__")
(def bucket-total-key "__usage_bucket_total__")

(def ^:private unlabelled-dimension "__usage_unlabelled_dimension__")

(defn dimension-label
  [dimension]
  (if (= dimension unlabelled-dimension) "Unknown" dimension))

(defn bucketed-series
  [rows dimension-key value-key]
  (let [dimension-of (fn [row] (or (get row dimension-key) unlabelled-dimension))
        dimension-totals (reduce (fn [totals row]
                                   (update totals (dimension-of row)
                                          (fnil + 0) (or (get row value-key) 0)))
                                 {} rows)
        series  (->> dimension-totals (sort-by val >) (mapv key))
        buckets (->> rows
                     (group-by :bucket)
                     (map (fn [[bucket bucket-rows]]
                            (reduce (fn [acc row]
                                     (let [v (or (get row value-key) 0)]
                                       (-> acc
                                           (assoc (dimension-of row) v)
                                           (update bucket-total-key + v))))
                                   {bucket-date-key bucket bucket-total-key 0}
                                   bucket-rows)))
                     (sort-by #(get % bucket-date-key))
                     vec)]
    {:rows buckets :series series}))

(def chart-tick-class "text-xs leading-4 text-kleene-text-secondary font-[IBM_Plex_Sans_Condensed]")
